import "./pdfjs-worker-setup";
import reportWebVitals from './reportWebVitals';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import './App.css';

// Add this import (create src/push/subscribePush.js as shown earlier)
import { ensurePushSubscription } from './push/subscribePush';

const root = createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>
);

// Register the Service Worker and subscribe to Web Push
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js') // make sure public/sw.js exists
      .then(() => navigator.serviceWorker.ready)
      .then(() => ensurePushSubscription())
      .catch((err) => {
        console.warn('SW registration / push subscription failed:', err);
      });
  });
}

// Performance reporting (unchanged)
reportWebVitals();

